/** Scopes supportés par le portail auth.semply.fr. */
export const OIDC_SCOPES = {
    OPENID: 'openid',
    PROFILE: 'profile',
    EMAIL: 'email',
    OFFLINE_ACCESS: 'offline_access',
};
export const SUPPORTED_SCOPES = Object.values(OIDC_SCOPES);
export const GRANT_TYPES = {
    AUTHORIZATION_CODE: 'authorization_code',
    REFRESH_TOKEN: 'refresh_token',
};
/**
 * Indicateur de ressource (RFC 8707) : préfixe des API de la suite.
 *
 * Un client autorisé (l'appli mobile) demande à /token un access token pour
 * UNE API donnée : `resource=urn:semply:api:semply-compta`. Le jeton émis porte
 * alors `aud: semply-compta` — l'audience que l'API de Compta vérifie déjà —,
 * et `client_id: semply-mobile`, le client qui l'a réellement obtenu.
 *
 * Un URN plutôt que l'URL de l'API : il vaut pour tous les environnements
 * (développement, préprod, production), là où l'URL change de l'un à l'autre.
 */
export const RESOURCE_INDICATOR_PREFIX = 'urn:semply:api:';
export const RESPONSE_TYPES = { CODE: 'code' };
/** Seule méthode PKCE acceptée : `plain` est refusé. */
export const CODE_CHALLENGE_METHODS = { S256: 'S256' };
export const SIGNING_ALG = 'RS256';
/** Chemins exposés par l'API (relatifs à l'issuer). */
export const OIDC_ROUTES = {
    DISCOVERY: '/.well-known/openid-configuration',
    JWKS: '/.well-known/jwks.json',
    AUTHORIZE: '/oidc/authorize',
    TOKEN: '/oidc/token',
    USERINFO: '/oidc/userinfo',
    REVOKE: '/oidc/revoke',
    LOGOUT: '/oidc/logout',
};
/** Écrans du portail vers lesquels /authorize peut rediriger. */
export const PORTAL_ROUTES = {
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/mot-de-passe-oublie',
    RESET_PASSWORD: '/reinitialiser',
    VERIFY_EMAIL: '/verification',
    MFA: '/mfa',
    CONSENT: '/consentement',
    // Écrans de confirmation d'inscription par fournisseur externe : l'API y
    // renvoie en `/inscription-<id du fournisseur>`.
    GOOGLE_SIGNUP: '/inscription-google',
    MICROSOFT_SIGNUP: '/inscription-microsoft',
    APPLE_SIGNUP: '/inscription-apple',
    ACCOUNT: '/compte',
    ERROR: '/erreur',
};
/** Libellés affichés sur l'écran de consentement, à la première personne. */
export const SCOPE_LABELS = {
    openid: { title: 'Vous identifier auprès de cette application' },
    profile: {
        title: 'Accéder à votre nom et votre photo',
        description: 'Prénom, nom, avatar et langue.',
    },
    email: {
        title: 'Accéder à votre adresse e-mail',
        description: 'Ainsi que son statut de vérification.',
    },
    offline_access: {
        title: 'Rester connecté',
        description: 'Sans vous demander vos identifiants à chaque visite.',
    },
};
//# sourceMappingURL=oidc.js.map